<template>
  <vs-sidebar
    click-not-close
    position-right
    v-model="dialogShow"
    class="items-no-padding lever-setting sidebar-dialog">
    <div class="sidebar-content">

      <div class="customizer-header flex items-center justify-between px-6 sliderbar-header">
        <div>
          {{title}}
        </div>
        <feather-icon icon="XIcon" @click.stop="closeHandle" class="cursor-pointer"></feather-icon>
      </div>
      <div class="content px-6">
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          label-position="top"
        >
          <el-form-item
            :label="$t('MT4_account')"
            prop="login"
          >
            <el-select
              :placeholder="$t('please_choose')"
              style="width: 100%"
              v-model="form.login"
              @change="loginChangeHandle"
            >
              <el-option
                v-for="(item,index) in accountList"
                :key="index"
                :label="item.login"
                :value="item.login"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            prop="lever"
          >
            <div style="display: inline-block" slot="label">
              <span>{{$t('Forex_Leverage')}}</span>
              <el-tooltip class="item" effect="dark" placement="top">
                <div slot="content">
                  <p
                    v-for="(item,index) in $t('mt4DetailSetting.leverTips')"
                    :key="index"
                  >{{item}}</p>
                </div>
                <i class="el-icon-info shuoming-icon"></i>
              </el-tooltip>
            </div>
            <el-select
              :placeholder="$t('please_choose')"
              style="width: 100%"
              v-model="form.lever"
              :disabled="leverDisabled"
            >
              <el-option
                v-for="(item,index) in leverList"
                :key="index"
                :label="item.levName"
                :value="item.lev"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div
      class="footer-sidebar" slot="footer">
      <el-button
        @click="cancelHandle"
        type="text"
        class="calcel-btn"
      >{{$t('cancel')}}</el-button>
      <vs-button
        :disabled="leverDisabled"
        @click="submitHandle"
        color="primary"
      >{{$t('Confirm')}}</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import { setBodyHidden,setBodyNormal } from "@/utils/common";
import { mapGetters } from 'vuex'
import {mtAccList,getGroupByName,modifyLev} from '@/api/userCenter.js';
export default {
  name: "leverageSetting",
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
    curLogin:{}
  },
  data() {
    let _this = this;
    return {
      title: _this.$t('User.leverSet'),
      leverList: [],
      accountList: [],
      selectAccount: null,
      leverDisabled: false,
      form: {
        login: '',
        lever: '',
      },
      rules:{
        login: [
          { required: true,message: _this.$t('withgold.selectAccount'), },
        ],
        lever: [
          { required: true,message: _this.$t('User.selectLev'), },
        ]
      }
    }
  },
  created(){
    this.getAccountList();
  },
  watch: {
    dialogShow(val){
      this.$refs.form && this.$refs.form.resetFields();
      this.$refs.form && this.$refs.form.clearValidate();
      if(val){
        setBodyHidden();
      }else {
        setBodyNormal();
      }
    },
    curLogin(newValue, oldValue) {
      if(newValue){
        this.form.login = newValue;
        for(let i = 0;i < this.accountList.length; i++){
          if(newValue ==this.accountList[i].login) {
            this.selectAccount= this.accountList[i]
            break;
          }
        }
        this.getGroupByName(() => {
          if(this.selectAccount){
            this.form.lever = this.selectAccount.leverage;
          }
        });

        this.$refs.form && this.$refs.form.clearValidate();
      }
    },
    'form.login'(newValue){

    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  methods: {
    getGroupByName(callback){
      if(this.selectAccount!=null) {
        let mtAccListData = {
          group : this.selectAccount.group
        }
        getGroupByName(mtAccListData).then((res) => {
          var leverageList = res.data[0].leverageList;
          let levList = leverageList.split(',');
          let tempList = [];
          for(let i = 0;i<levList.length; i++){
            let lev = parseInt(levList[i]);
            let levName='1:'+ levList[i];
            let params = {
              levName:levName,
              lev:lev
            };
            tempList[i] = params;
          }
          this.leverList = tempList;
          callback && callback();
        })
      }
    },
    getAccountList(){
      let mtAccListData = {
        id : this.userInfo.id,
        isMock : '2',
        isTrial: false,
      }
      mtAccList(mtAccListData).then((res) => {
        this.accountList = res.data;
        if(res.data.length){
          for (let i = 0; i < res.data.length; i++) {
            if(this.curLogin == res.data[i].login){
              this.form.login = res.data[i].login;
              this.selectAccount= res.data[i];
              this.leverDisabled = res.data[i].openLeverage ? false : true;
              break;
            }
          }
          if(this.selectAccount){
            this.form.lever = this.selectAccount.leverage;
          }
        }
      })
    },
    loginChangeHandle(){
      this.$refs.form && this.$refs.form.clearValidate(['login']);
    },
    reset(){
      this.form.login = '';
      this.form.lever = '';
    },
    close(){
      this.reset();
      this.$emit('close')
    },
    closeHandle() {
      this.$refs.form && this.$refs.form.resetFields();
      this.$refs.form && this.$refs.form.clearValidate();
      this.close();
    },
    interfaceAjaxSuccess(){
      this.$emit('ajax-success');
    },
    submitHandle(){
      if(this.leverDisabled) return;
      let modifyLevData = {
        custId : this.userInfo.id,
        leverage : this.form.lever,
        login : this.form.login,
      }
      modifyLev(modifyLevData).then((res) => {
        this.$message({
          message: this.$t('User.modifyLeverSuccess'),
          type: 'success'
        });
        this.interfaceAjaxSuccess();
      })
    },
    cancelHandle(){
      this.close();
    }
  },
}
</script>
<style lang="scss">
.lever-setting {
  .content {
    padding-top: 30px;
  }
}
</style>
<style lang="scss">
// sidebar弹窗的统一弹窗样式,层级
.lever-setting {
  .shuoming-icon {
    margin-left: 5px;
  }
  .vs-sidebar--items {

  }
  .vs-sidebar {
    z-index: 1002;
    position: fixed;
    .sidebar-content {
    }
  }
  // sidebar弹框的遮罩层
  .vs-sidebar--background {
    z-index: 1001!important;
  }
  .footer-sidebar {
    padding: 20px 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .calcel-btn {
      margin-right: 10px;
    }
  }
}
</style>
